/**
 * Builds the sandbox URL used for reviewing a migrated Help Center draft.
 *
 * Keep this shared by migration entry points. Multi-help-center routes use the
 * legacy help center slug as the review-route identifier. The default Help
 * Center has no slug and continues to use its legacy portals route.
 */
export const buildMigratedHelpCenterReviewUrl = ({
	baseUrl,
	slug,
}: {
	baseUrl: string;
	slug?: string | null;
}): string =>
	new URL(
		slug ? `/helpcenter/test/${encodeURIComponent(slug)}` : '/servicedesk/customer/test/portals',
		baseUrl,
	).toString();
